const URL_IMAGES = {
  FEEDBACK: {
    SUCCESS: 'sellers/feedback/success.svg',
    ERROR: 'sellers/feedback/error.svg',
  },
  HERO: {
    DESKTOP: 'sellers/hero/desktop.svg',
    MOBILE: 'sellers/hero/mobile.svg',
  },
  BOOTS: {
    TOOLS_1: 'sellers/boosts/tools-1.svg',
    TOOLS_2: 'sellers/boosts/tools-2.svg',
    TOOLS_3: 'sellers/boosts/tools-3.svg',
  },
  CONSULT: {
    DESKTOP: 'sellers/consult/desktop.svg',
    MOBILE: 'sellers/consult/mobile-1.svg',
    STEP_1: 'sellers/consult/step-1.svg',
    STEP_2: 'sellers/consult/step-2.svg',
    STEP_3: 'sellers/consult/step-3.svg',
  },
  BENEFITS: {
    DESKTOP: 'sellers/benefits/desktop.svg',
    MOBILE: 'sellers/benefits/mobile.svg',
  },
  SALES: {
    DESKTOP: 'sellers/sales/desktop.svg',
    MOBILE: 'sellers/sales/mobile.svg',
  },
  PLATFORM: {
    DESKTOP: 'sellers/platform/desktop.svg',
    MOBILE: 'sellers/platform/mobile.svg',
  },
  SHARED: {
    DESKTOP: 'sellers/shared-info/desktop.svg',
  },
  TOOLKIT: {
    LEFT: 'sellers/toolkit/left.svg',
    RIGHT: 'sellers/toolkit/right.svg',
  },
};

const PREFIX_IMAGES = {
  MP_DEFAULT_THEME: 'mp-default-theme/',
  MP_YELLOW_THEME: 'mp-yellow-theme/',
};

export const IMAGES = {
  URL: URL_IMAGES,
  PREFIX: PREFIX_IMAGES,
};
